import React from 'react';
export function StairsIcon() {
  return (
    <span
      style={{
        width: 23,
        marginRight: '10px',
      }}
      className="material-icons"
    >
      square_foots
    </span>
  );
}

export function SettingsIcon() {
  return (
    <span style={{ marginRight: '10px' }} className="material-icons">
      call_split
    </span>
  );
}

export function DispoIcon() {
  return (
    <span style={{ marginRight: '10px' }} className="material-icons">
      account_box
    </span>
  );
}

export function ReviewIcon() {
  return (
    <span style={{ marginRight: '10px' }} className="material-icons">
      playlist_add_check
    </span>
  );
}
